import Alert from "@pathwright/ui/src/components/alert/Alert"
import PropTypes from "prop-types"
import {
  FeatureAction,
  FeatureContextInput,
  FeatureKey,
  FeaturePermission,
  useContextualFeaturePermissionQuery
} from "@pathwright/graphql-client/src/generated"
import {
  featureActionPropType,
  featureContextPropType,
  featureKeyPropType
} from "../propTypes"
import FeatureBlock from "./FeatureBlock"

const FeatureBlockContainer = ({
  featureKey,
  featureAction,
  context,
  to,
  description
}: {
  featureKey: FeatureKey
  featureAction: FeatureAction
  context: FeatureContextInput | null
  to?: string | object | null
  description?: string | React.ReactNode
}) => {
  const cfpQuery = useContextualFeaturePermissionQuery({
    variables: {
      featureKey,
      featureAction,
      context
    }
  })

  if (cfpQuery.loading) return null
  if (cfpQuery.error) return <Alert error={cfpQuery.error} />

  const feature = cfpQuery.data?.contextualFeaturePermission

  // The ContextualFeaturePermission may not exist yet;
  // that's ok—we can assume it is disabled, and have it be upserted by the feature's form.
  // We can safely default to disabled because only CFPs configured to default to disabled
  // are not created by default by the backend.
  return (
    <FeatureBlock
      featureKey={feature?.feature_key || featureKey}
      featurePermission={
        feature?.permission_in_context || FeaturePermission.Disabled
      }
      to={to}
      description={description}
    />
  )
}

FeatureBlockContainer.displayName = "FeatureBlockContainer"

FeatureBlockContainer.propTypes = {
  feature_action: featureActionPropType,
  feature_key: featureKeyPropType,
  context: PropTypes.oneOf([featureContextPropType, null]),
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
}

export default FeatureBlockContainer
